import Moment from "react-moment";

function ToolTipContent({ data }) {
  if (data.downloadConfirmations) {
    return (
      <div className="tooltip-container">
        <h6 className="tooltip-list-header">Downloadbestätigungen</h6>
        <ul className="tooltip-list tooltip-download-list mb-0">
          {data.downloadConfirmations.map(
            ({ blobsUpdatedAt, confirmDate, systemId }, index) => (
              <li
                className="tooltip-download-list-item"
                key={`${systemId}-${confirmDate}-${index}`}
              >
                <p className="tooltip-list-item-value m-0">
                  <strong>Freigegeben am:&nbsp;</strong>
                  <Moment
                    format="HH:mm:ss, DD.MM.YYYY"
                    interval={0}
                    tz="Europe/Berlin"
                  >
                    {blobsUpdatedAt}
                  </Moment>
                </p>
                <p className="tooltip-list-item-value m-0">
                  <strong>Abgeholt am:&nbsp;</strong>
                  <Moment
                    format="HH:mm:ss, DD.MM.YYYY"
                    interval={0}
                    tz="Europe/Berlin"
                  >
                    {confirmDate}
                  </Moment>
                </p>
                <p className="tooltip-list-item-value m-0">
                  <strong>Client ID:&nbsp;</strong>
                  {systemId}
                </p>
              </li>
            ),
          )}
        </ul>
      </div>
    );
  }

  const {
    name,
    value,
    workstepInfo: { currentWorkstep, worksteps },
  } = data;

  return (
    <div className="tooltip-container">
      <h6 className="tooltip-list-header">{name}</h6>
      <div className="tooltip-list">
        {value === "Entwurf" && (
          <p className="tooltip-list-item-value">
            Bitte öffnen Sie die Mappe, um sie fertigzustellen und zu versenden.
          </p>
        )}
        {worksteps &&
          worksteps.map((step, i) => {
            let status;

            if (step.workstepStatus !== "signed") {
              status = step.emailSent;
            } else {
              status = "signiert";
            }

            const workstepNum = i + 1;

            return (
              <div
                className={`tooltip-list-item ${
                  workstepNum > currentWorkstep && "tooltip-list-item-light"
                }`}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1.6rem 1fr",
                  columnGap: "0.25rem",
                }}
                key={i}
              >
                <div
                  className="workstep-num"
                  style={{ gridColumn: 1, gridRow: 1 }}
                >
                  {workstepNum}.
                </div>

                <div style={{ gridColumn: 2, gridRow: 1 }}>
                  {step.workstepId}:
                </div>

                {step.fullName && (
                  <div
                    className="tooltip-list-item-value m-0"
                    style={{ gridColumn: 2, gridRow: 2 }}
                  >
                    <strong>Name:&nbsp;</strong>
                    {step.fullName}
                  </div>
                )}

                <div
                  className="tooltip-list-item-value m-0"
                  style={{ gridColumn: 2, gridRow: 3 }}
                >
                  <strong>Status:&nbsp;</strong>
                  {status}
                  {status === "signiert" && (
                    <i className="fas fa-check-circle ml-1 tooltip-signed-checkmark" />
                  )}
                </div>
                {step.emailSentAt && (
                  <div
                    className="tooltip-list-item-value m-0"
                    style={{ gridColumn: 2, gridRow: 4, whiteSpace: "nowrap" }}
                  >
                    <strong>Datum:&nbsp;</strong>
                    {step.emailSentAt}
                  </div>
                )}
              </div>
            );
          })}
        {!worksteps && value !== "Entwurf" && (
          <p className="tooltip-list-item-value">{value}</p>
        )}
      </div>
    </div>
  );
}

export default ToolTipContent;
